import { render, staticRenderFns } from "./options-criteria-color-form.vue?vue&type=template&id=0fc54a69&scoped=true&"
import script from "./options-criteria-color-form.vue?vue&type=script&lang=js&"
export * from "./options-criteria-color-form.vue?vue&type=script&lang=js&"
import style0 from "./options-criteria-color-form.vue?vue&type=style&index=0&id=0fc54a69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc54a69",
  null
  
)

export default component.exports